import React, { useState } from 'react';
import { StarIcon } from '@heroicons/react/20/solid';

const DoctorCard = ({ doctor, index = 0 }) => {
  const [showMap, setShowMap] = useState(false);

  // Buscar el website en contact.website
  const website = doctor.contact?.website || '#';

  console.log('Doctor data:', doctor);

  console.log('Doctor data:', {
    name: doctor.name,
    website,
    websiteType: typeof website,
    contactWebsite: doctor.contact?.website,
    fullDoctor: doctor,
    index
  });

  const validWebsites = doctor.websites?.filter(website => {
    const linkType = website?.url ? 'external' : null;
    return linkType !== null;
  }) || [];

  // Asegurarnos de que rating tenga valores por defecto
  const rating = doctor.rating || { average: 0, total_reviews: 0 };

  const getLinkText = (url) => {
    if (!url) return 'Sitio Web';
    
    const socialMedia = {
      'facebook.com': 'Facebook',
      'fb.com': 'Facebook',
      'instagram.com': 'Instagram',
      'wa.me': 'WhatsApp',
      'api.whatsapp.com': 'WhatsApp',
      'linkedin.com': 'LinkedIn',
      'twitter.com': 'Twitter',
      'doctoralia': 'Doctoralia'
    };

    const domain = Object.keys(socialMedia).find(domain => url.toLowerCase().includes(domain));
    return domain ? socialMedia[domain] : 'Sitio Web';
  };

  const renderRating = () => {
    if (!doctor.rating?.average) return null;

    return (
      <div className="flex items-center space-x-2">
        <div className="flex items-center">
          {[...Array(5)].map((_, i) => (
            <StarIcon
              key={i}
              className={`h-5 w-5 ${
                i < Math.floor(doctor.rating.average)
                  ? 'text-yellow-400'
                  : 'text-gray-200'
              }`}
            />
          ))}
        </div>
        <span className="text-lg font-semibold text-gray-700">
          {doctor.rating.average.toFixed(1)}
        </span>
        <span className="text-sm text-gray-500">
          ({doctor.rating.total_reviews} reseñas)
        </span>
      </div>
    );
  };

  return (
    <div className="doctor-card" itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
      <meta itemProp="position" content={index + 1} />
      <div itemScope itemType="https://schema.org/Physician" data-category={doctor.main_category} data-index={index}>
        <div className="bg-white rounded-lg shadow-card p-6 hover:shadow-card-hover transition-shadow">
          <div>
            <h2 itemProp="name" className="text-xl font-semibold text-gray-900 mb-2">
              {doctor.name}
            </h2>

            {/* Rating y reviews */}
            <div className="flex items-center mb-2">
              <div className="flex items-center">
                {[...Array(5)].map((_, i) => (
                  <StarIcon
                    key={i}
                    className={`h-5 w-5 ${
                      i < Math.round(rating.average)
                        ? 'text-yellow-400'
                        : 'text-gray-300'
                    }`}
                  />
                ))}
              </div>
              <span className="ml-2 text-sm text-gray-600">
                {rating.total_reviews} {rating.total_reviews === 1 ? 'opinión' : 'opiniones'}
              </span>
            </div>

            {/* Dirección */}
            {doctor.location?.address && (
              <p className="text-gray-600 mb-2">
                📍 {doctor.location.address}
              </p>
            )}

            {/* Teléfono */}
            {doctor.contact?.phone && (
              <p className="text-gray-600 mb-2">
                📞 {doctor.contact.phone}
              </p>
            )}

            {/* Horario */}
            {doctor.schedule?.workdays && (
              <p className="text-gray-600 mb-4">
                🕒 {doctor.schedule.workdays}
              </p>
            )}

            {/* Botones de acción */}
            <div className="mt-4 flex flex-wrap gap-2">
              {doctor.phone && (
                <a
                  href={`tel:${doctor.phone}`}
                  className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                >
                  Llamar
                </a>
              )}

              {doctor.location?.mapUrl && (
                <button
                  onClick={() => setShowMap(!showMap)}
                  className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                >
                  Ver ubicación
                </button>
              )}

              {doctor.contact?.website && (
                <a
                  href={`/redirect?to=${encodeURIComponent(doctor.contact?.website || '')}`}
                  className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                  rel="nofollow noopener noreferrer"
                >
                  Sitio Web
                </a>
              )}

              {validWebsites.length > 0 && (
                <a
                  href={`/redirect?to=${encodeURIComponent(validWebsites[0].url)}`}
                  className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                  rel="nofollow noopener noreferrer"
                >
                  Agendar cita
                </a>
              )}
            </div>
          </div>

          {/* Mapa */}
          {showMap && doctor.location?.coordinates && (
            <div className="mt-4 rounded-lg overflow-hidden">
              <iframe
                width="100%"
                height="300"
                frameBorder="0"
                scrolling="no"
                marginHeight="0"
                marginWidth="0"
                src={`https://www.openstreetmap.org/export/embed.html?bbox=${doctor.location.coordinates.lng-0.01},${doctor.location.coordinates.lat-0.01},${doctor.location.coordinates.lng+0.01},${doctor.location.coordinates.lat+0.01}&layer=mapnik&marker=${doctor.location.coordinates.lat},${doctor.location.coordinates.lng}`}
                style={{ borderRadius: '0.5rem' }}
              ></iframe>
              <div className="bg-white p-4 border-t">
                <p className="text-gray-700 mb-2">{doctor.location.address}</p>
                <div className="flex gap-2">
                  {doctor.location.mapUrl && (
                    <a 
                      href={doctor.location.mapUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary-600 hover:text-primary-700 inline-block"
                    >
                      Ver en Google Maps →
                    </a>
                  )}
                  <a 
                    href={`https://www.openstreetmap.org/?mlat=${doctor.location.coordinates.lat}&mlon=${doctor.location.coordinates.lng}&zoom=15`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary-600 hover:text-primary-700 inline-block"
                  >
                    Ver en OpenStreetMap →
                  </a>
                </div>
              </div>
            </div>
          )}

          {/* Agregar la calificación numérica junto a las estrellas */}
          <div className="mt-2">
            {renderRating()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorCard; 